@let c = cell();

<div #origin="cdkOverlayOrigin"
     cdkOverlayOrigin
     class="pl-list-cell"
     [class]="statusClass()"
     [class.pl-list-cell--today]="c.isToday"
     [class.pl-list-cell--past]="c.isPast"
     [class.pl-list-cell--dense]="!comfortable()"
     [class.pl-list-cell--placeholder]="expanded()"
     (click)="onClick()">

  <ng-container *ngTemplateOutlet="cellContent; context: { $implicit: false }"/>
</div>

<!-- Overlay CDK : teleporté au body, échappe les overflow:hidden et transforms.
     `cdkConnectedOverlayPush` : si la position préférée déborde du viewport,
     pousse l'overlay pour qu'il reste entièrement visible (évite le cutoff
     quand le widget est en bas de page). `viewportMargin` : marge minimale
     avec les bords du viewport. -->
<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="expanded()"
  [cdkConnectedOverlayPositions]="overlayPositions"
  [cdkConnectedOverlayWidth]="cellWidth() + 2"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayPush]="true"
  [cdkConnectedOverlayViewportMargin]="8"
  cdkConnectedOverlayBackdropClass="pl-list-cell__cdk-backdrop"
  (backdropClick)="closeExpand()"
  (detach)="closeExpand()">

  <!-- Click sur overlay (zone vide) → ferme le focus mode.
       Les event-rows et le chevron ont leur propre stopPropagation, donc
       les clics qui nous arrivent ici sont bien "zone neutre". -->
  <div class="pl-list-cell pl-list-cell--overlay"
       [class]="statusClass()"
       [class.pl-list-cell--today]="c.isToday"
       [class.pl-list-cell--dense]="!comfortable()"
       (click)="onOverlayClick($event)">

    <ng-container *ngTemplateOutlet="cellContent; context: { $implicit: true }"/>
  </div>
</ng-template>

<ng-template #cellContent let-isOverlay>
  <header class="pl-list-cell__header">
    <span class="pl-list-cell__day">{{ dayLabel() }}</span>
    @if (c.isToday) {
      <span class="pl-list-cell__today-dot">●</span>
    }
    @if (c.events.length > 0) {
      <span class="pl-list-cell__count">{{ c.events.length }}</span>
    }
  </header>

  <div class="pl-list-cell__events">
    @for (event of (isOverlay ? c.events : displayedEvents()); track event.id) {
      <!-- Event-row : ligne entière cliquable (zone large, plus naturelle).
           Le chevron reste comme affordance visuelle. -->
      <div class="pl-list-cell__event-row pl-list-cell__event-row--clickable"
           [class.pl-list-cell__event-row--late]="event.status === 'late'"
           [matTooltip]="eventTooltip(event)"
           matTooltipPosition="right"
           matTooltipShowDelay="200"
           [matTooltipClass]="'pl-tooltip-multiline'"
           role="button"
           tabindex="0"
           (click)="onEventClick(event, $event)"
           (keydown.enter)="onEventClick(event, $event)">

        <span class="pl-list-cell__source" [class]="eventSourceClass(event)">
          {{ eventSourceLabel(event) }}
        </span>

        <span class="pl-list-cell__event-title">{{ eventTitle(event) }}</span>

        <span class="pl-list-cell__event-nav" aria-hidden="true">
          <mat-icon>chevron_right</mat-icon>
        </span>

        <span class="pl-list-cell__event-subtitle">{{ eventSubtitle(event) }}</span>
      </div>
    } @empty {
      <span class="pl-list-cell__empty">·</span>
    }
  </div>

  @if (overflowCount() > 0) {
    <button type="button"
            class="pl-list-cell__expand-btn"
            (click)="toggleExpand($event)">
      @if (isOverlay) {
        ▲ réduire
      } @else {
        ▼ +{{ overflowCount() }} autre{{ overflowCount() > 1 ? 's' : '' }}
      }
    </button>
  }
</ng-template>
